import { Injector } from '@angular/core';
import { DeSnackbarData } from './de-snackbar-config';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { DeSnackbarRef } from './de-snackbar-ref';
// import { DeSnackbarComponent } from '@de-electron/electron-angular-components';
import { DeSnackbarComponent } from './de-snackbar.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/overlay";
export class DeSnackbarService {
    constructor(overlay, parentInjector) {
        this.overlay = overlay;
        this.parentInjector = parentInjector;
    }
    show(data) {
        this.destroyLastSnackbar(this.lastSnackbar);
        const positionStrategy = this.getPositionStrategy(data);
        const overlayRef = this.overlay.create({ positionStrategy });
        data._position = this.getPosition(data);
        const snackbarRef = new DeSnackbarRef(overlayRef);
        this.lastSnackbar = snackbarRef;
        const injector = this.getInjector(data, snackbarRef, this.parentInjector);
        const SnackbarPortal = new ComponentPortal(DeSnackbarComponent, null, injector);
        const snackbarComponentRef = overlayRef.attach(SnackbarPortal);
        snackbarRef.onLinkClick = snackbarComponentRef.instance.linkClick;
        return snackbarRef;
    }
    getPosition(data) {
        const width = window.innerWidth;
        const mobilePosition = data.mobilePosition || 'bottom';
        const desktopPosition = data.desktopPosition || 'top';
        return (width < 768) ? mobilePosition : desktopPosition;
    }
    getPositionStrategy(data) {
        const width = window.innerWidth;
        const position = this.overlay.position().global();
        if (width < 768) {
            if (data.mobilePosition === 'top') {
                position.top(`${80 + (data.mobileOffset || 0)}px`);
            }
            else {
                position.bottom(`${80 + (data.mobileOffset || 0)}px`);
            }
        }
        else {
            if (data.desktopPosition === 'bottom') {
                position.bottom(`${80 + (data.desktopOffset || 0)}px`);
            }
            else {
                position.top(`${80 + (data.desktopOffset || 0)}px`);
            }
        }
        position.centerHorizontally();
        return position;
    }
    destroyLastSnackbar(snackbarRef) {
        if (snackbarRef) {
            setTimeout(() => { snackbarRef.close(); }, 200);
        }
    }
    getInjector(data, snackbarRef, parentInjector) {
        const tokens = new WeakMap();
        tokens.set(DeSnackbarData, data);
        tokens.set(DeSnackbarRef, snackbarRef);
        return new PortalInjector(parentInjector, tokens);
    }
}
DeSnackbarService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeSnackbarService_Factory() { return new DeSnackbarService(i0.ɵɵinject(i1.Overlay), i0.ɵɵinject(i0.INJECTOR)); }, token: DeSnackbarService, providedIn: "root" });
